import React from 'react';
import DeliveryDetails from './deliveryDetailsComponent';
import DeliveryDate from './dateDeliveryComponent';
import DeliveryComments from './deliveryCommentsComponent';
import './orderDetails.css';


const OrderDetails = (props) => {
  return (
    <div className="order-details-breadcrumb-container">
      <DeliveryDetails
        user={props.user}
        deliverToValue={props.deliverToValue}
        setDeliveryTo={props.setDeliveryTo}
        setHasErrors={props.setHasErrors}
        canUseCustomerOverride={props.canUseCustomerOverride}
        customerOverride={props.customerOverride}
        setCustomerOverride={props.setCustomerOverride}
      />
      <DeliveryDate
        setDeliveryDate={props.setDeliveryDate}
        setHasErrors={props.setHasErrors}
      />
      <DeliveryComments
        setDeliveryComments={props.setDeliveryComments}
      />
    </div>
  )
};

export default OrderDetails;
